/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as BiRouteImport } from './routes/bi'
import { Route as CompetidoresRouteImport } from './routes/competidores'
import { Route as ConfiguracionRouteImport } from './routes/configuracion'
import { Route as ConveniosMarcoRouteImport } from './routes/convenios-marco'
import { Route as CrmRouteImport } from './routes/crm'
import { Route as DashboardIaRouteImport } from './routes/dashboard-ia'
import { Route as DecisionesRouteImport } from './routes/decisiones'
import { Route as DocumentosRouteImport } from './routes/documentos'
import { Route as EmpresaRouteImport } from './routes/empresa'
import { Route as IaRouteImport } from './routes/ia'
import { Route as LicitacionesRouteImport } from './routes/licitaciones'
import { Route as NotificacionesRouteImport } from './routes/notificaciones'
import { Route as OrdenesCompraRouteImport } from './routes/ordenes-compra'
import { Route as PerfilamientoRouteImport } from './routes/perfilamiento'
import { Route as WatchlistRouteImport } from './routes/watchlist'
import { Route as BiIndexRouteImport } from './routes/bi.index'
import { Route as BiCategoriasRouteImport } from './routes/bi.categorias'
import { Route as BiIaRouteImport } from './routes/bi.ia'
import { Route as BiMercadoRouteImport } from './routes/bi.mercado'
import { Route as BiOrganismosRouteImport } from './routes/bi.organismos'
import { Route as BiPipelineRouteImport } from './routes/bi.pipeline'
import { Route as BiPlazosRouteImport } from './routes/bi.plazos'
import { Route as CompetidoresIdRouteImport } from './routes/competidores.$id'
import { Route as CompraAgilIaIndexRouteImport } from './routes/compra-agil-ia.index'
import { Route as CompraAgilIaIdRouteImport } from './routes/compra-agil-ia.$id'
import { Route as CompraAgilIndexRouteImport } from './routes/compra-agil.index'
import { Route as CompraAgilIdRouteImport } from './routes/compra-agil.$id'
import { Route as LicitacionesIndexRouteImport } from './routes/licitaciones.index'
import { Route as LicitacionesIdRouteImport } from './routes/licitaciones.$id'
import { Route as OportunidadesIndexRouteImport } from './routes/oportunidades.index'
import { Route as OportunidadesIdRouteImport } from './routes/oportunidades.$id'
import { Route as OrdenesCompraIndexRouteImport } from './routes/ordenes-compra.index'
import { Route as OrdenesCompraCodigoRouteImport } from './routes/ordenes-compra.$codigo'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const BiRoute = BiRouteImport.update({
  id: '/bi',
  path: '/bi',
  getParentRoute: () => rootRouteImport,
} as any)
const CompetidoresRoute = CompetidoresRouteImport.update({
  id: '/competidores',
  path: '/competidores',
  getParentRoute: () => rootRouteImport,
} as any)
const ConfiguracionRoute = ConfiguracionRouteImport.update({
  id: '/configuracion',
  path: '/configuracion',
  getParentRoute: () => rootRouteImport,
} as any)
const ConveniosMarcoRoute = ConveniosMarcoRouteImport.update({
  id: '/convenios-marco',
  path: '/convenios-marco',
  getParentRoute: () => rootRouteImport,
} as any)
const CrmRoute = CrmRouteImport.update({
  id: '/crm',
  path: '/crm',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardIaRoute = DashboardIaRouteImport.update({
  id: '/dashboard-ia',
  path: '/dashboard-ia',
  getParentRoute: () => rootRouteImport,
} as any)
const DecisionesRoute = DecisionesRouteImport.update({
  id: '/decisiones',
  path: '/decisiones',
  getParentRoute: () => rootRouteImport,
} as any)
const DocumentosRoute = DocumentosRouteImport.update({
  id: '/documentos',
  path: '/documentos',
  getParentRoute: () => rootRouteImport,
} as any)
const EmpresaRoute = EmpresaRouteImport.update({
  id: '/empresa',
  path: '/empresa',
  getParentRoute: () => rootRouteImport,
} as any)
const IaRoute = IaRouteImport.update({
  id: '/ia',
  path: '/ia',
  getParentRoute: () => rootRouteImport,
} as any)
const LicitacionesRoute = LicitacionesRouteImport.update({
  id: '/licitaciones',
  path: '/licitaciones',
  getParentRoute: () => rootRouteImport,
} as any)
const NotificacionesRoute = NotificacionesRouteImport.update({
  id: '/notificaciones',
  path: '/notificaciones',
  getParentRoute: () => rootRouteImport,
} as any)
const OrdenesCompraRoute = OrdenesCompraRouteImport.update({
  id: '/ordenes-compra',
  path: '/ordenes-compra',
  getParentRoute: () => rootRouteImport,
} as any)
const PerfilamientoRoute = PerfilamientoRouteImport.update({
  id: '/perfilamiento',
  path: '/perfilamiento',
  getParentRoute: () => rootRouteImport,
} as any)
const WatchlistRoute = WatchlistRouteImport.update({
  id: '/watchlist',
  path: '/watchlist',
  getParentRoute: () => rootRouteImport,
} as any)
const BiIndexRoute = BiIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => BiRoute,
} as any)
const BiCategoriasRoute = BiCategoriasRouteImport.update({
  id: '/categorias',
  path: '/categorias',
  getParentRoute: () => BiRoute,
} as any)
const BiIaRoute = BiIaRouteImport.update({
  id: '/ia',
  path: '/ia',
  getParentRoute: () => BiRoute,
} as any)
const BiMercadoRoute = BiMercadoRouteImport.update({
  id: '/mercado',
  path: '/mercado',
  getParentRoute: () => BiRoute,
} as any)
const BiOrganismosRoute = BiOrganismosRouteImport.update({
  id: '/organismos',
  path: '/organismos',
  getParentRoute: () => BiRoute,
} as any)
const BiPipelineRoute = BiPipelineRouteImport.update({
  id: '/pipeline',
  path: '/pipeline',
  getParentRoute: () => BiRoute,
} as any)
const BiPlazosRoute = BiPlazosRouteImport.update({
  id: '/plazos',
  path: '/plazos',
  getParentRoute: () => BiRoute,
} as any)
const CompetidoresIdRoute = CompetidoresIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => CompetidoresRoute,
} as any)
const CompraAgilIaIndexRoute = CompraAgilIaIndexRouteImport.update({
  id: '/compra-agil-ia/',
  path: '/compra-agil-ia/',
  getParentRoute: () => rootRouteImport,
} as any)
const CompraAgilIaIdRoute = CompraAgilIaIdRouteImport.update({
  id: '/compra-agil-ia/$id',
  path: '/compra-agil-ia/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const CompraAgilIndexRoute = CompraAgilIndexRouteImport.update({
  id: '/compra-agil/',
  path: '/compra-agil/',
  getParentRoute: () => rootRouteImport,
} as any)
const CompraAgilIdRoute = CompraAgilIdRouteImport.update({
  id: '/compra-agil/$id',
  path: '/compra-agil/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const LicitacionesIndexRoute = LicitacionesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LicitacionesRoute,
} as any)
const LicitacionesIdRoute = LicitacionesIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => LicitacionesRoute,
} as any)
const OportunidadesIndexRoute = OportunidadesIndexRouteImport.update({
  id: '/oportunidades/',
  path: '/oportunidades/',
  getParentRoute: () => rootRouteImport,
} as any)
const OportunidadesIdRoute = OportunidadesIdRouteImport.update({
  id: '/oportunidades/$id',
  path: '/oportunidades/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const OrdenesCompraIndexRoute = OrdenesCompraIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OrdenesCompraRoute,
} as any)
const OrdenesCompraCodigoRoute = OrdenesCompraCodigoRouteImport.update({
  id: '/$codigo',
  path: '/$codigo',
  getParentRoute: () => OrdenesCompraRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/bi': typeof BiRouteWithChildren
  '/competidores': typeof CompetidoresRouteWithChildren
  '/configuracion': typeof ConfiguracionRoute
  '/convenios-marco': typeof ConveniosMarcoRoute
  '/crm': typeof CrmRoute
  '/dashboard-ia': typeof DashboardIaRoute
  '/decisiones': typeof DecisionesRoute
  '/documentos': typeof DocumentosRoute
  '/empresa': typeof EmpresaRoute
  '/ia': typeof IaRoute
  '/licitaciones': typeof LicitacionesRouteWithChildren
  '/notificaciones': typeof NotificacionesRoute
  '/ordenes-compra': typeof OrdenesCompraRouteWithChildren
  '/perfilamiento': typeof PerfilamientoRoute
  '/watchlist': typeof WatchlistRoute
  '/bi/categorias': typeof BiCategoriasRoute
  '/bi/ia': typeof BiIaRoute
  '/bi/mercado': typeof BiMercadoRoute
  '/bi/organismos': typeof BiOrganismosRoute
  '/bi/pipeline': typeof BiPipelineRoute
  '/bi/plazos': typeof BiPlazosRoute
  '/competidores/$id': typeof CompetidoresIdRoute
  '/compra-agil-ia/$id': typeof CompraAgilIaIdRoute
  '/compra-agil/$id': typeof CompraAgilIdRoute
  '/licitaciones/$id': typeof LicitacionesIdRoute
  '/oportunidades/$id': typeof OportunidadesIdRoute
  '/ordenes-compra/$codigo': typeof OrdenesCompraCodigoRoute
  '/bi/': typeof BiIndexRoute
  '/compra-agil-ia/': typeof CompraAgilIaIndexRoute
  '/compra-agil/': typeof CompraAgilIndexRoute
  '/licitaciones/': typeof LicitacionesIndexRoute
  '/oportunidades/': typeof OportunidadesIndexRoute
  '/ordenes-compra/': typeof OrdenesCompraIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/competidores': typeof CompetidoresRouteWithChildren
  '/configuracion': typeof ConfiguracionRoute
  '/convenios-marco': typeof ConveniosMarcoRoute
  '/crm': typeof CrmRoute
  '/dashboard-ia': typeof DashboardIaRoute
  '/decisiones': typeof DecisionesRoute
  '/documentos': typeof DocumentosRoute
  '/empresa': typeof EmpresaRoute
  '/ia': typeof IaRoute
  '/notificaciones': typeof NotificacionesRoute
  '/perfilamiento': typeof PerfilamientoRoute
  '/watchlist': typeof WatchlistRoute
  '/bi/categorias': typeof BiCategoriasRoute
  '/bi/ia': typeof BiIaRoute
  '/bi/mercado': typeof BiMercadoRoute
  '/bi/organismos': typeof BiOrganismosRoute
  '/bi/pipeline': typeof BiPipelineRoute
  '/bi/plazos': typeof BiPlazosRoute
  '/competidores/$id': typeof CompetidoresIdRoute
  '/compra-agil-ia/$id': typeof CompraAgilIaIdRoute
  '/compra-agil/$id': typeof CompraAgilIdRoute
  '/licitaciones/$id': typeof LicitacionesIdRoute
  '/oportunidades/$id': typeof OportunidadesIdRoute
  '/ordenes-compra/$codigo': typeof OrdenesCompraCodigoRoute
  '/bi': typeof BiIndexRoute
  '/compra-agil-ia': typeof CompraAgilIaIndexRoute
  '/compra-agil': typeof CompraAgilIndexRoute
  '/licitaciones': typeof LicitacionesIndexRoute
  '/oportunidades': typeof OportunidadesIndexRoute
  '/ordenes-compra': typeof OrdenesCompraIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/bi': typeof BiRouteWithChildren
  '/competidores': typeof CompetidoresRouteWithChildren
  '/configuracion': typeof ConfiguracionRoute
  '/convenios-marco': typeof ConveniosMarcoRoute
  '/crm': typeof CrmRoute
  '/dashboard-ia': typeof DashboardIaRoute
  '/decisiones': typeof DecisionesRoute
  '/documentos': typeof DocumentosRoute
  '/empresa': typeof EmpresaRoute
  '/ia': typeof IaRoute
  '/licitaciones': typeof LicitacionesRouteWithChildren
  '/notificaciones': typeof NotificacionesRoute
  '/ordenes-compra': typeof OrdenesCompraRouteWithChildren
  '/perfilamiento': typeof PerfilamientoRoute
  '/watchlist': typeof WatchlistRoute
  '/bi/categorias': typeof BiCategoriasRoute
  '/bi/ia': typeof BiIaRoute
  '/bi/mercado': typeof BiMercadoRoute
  '/bi/organismos': typeof BiOrganismosRoute
  '/bi/pipeline': typeof BiPipelineRoute
  '/bi/plazos': typeof BiPlazosRoute
  '/competidores/$id': typeof CompetidoresIdRoute
  '/compra-agil-ia/$id': typeof CompraAgilIaIdRoute
  '/compra-agil/$id': typeof CompraAgilIdRoute
  '/licitaciones/$id': typeof LicitacionesIdRoute
  '/oportunidades/$id': typeof OportunidadesIdRoute
  '/ordenes-compra/$codigo': typeof OrdenesCompraCodigoRoute
  '/bi/': typeof BiIndexRoute
  '/compra-agil-ia/': typeof CompraAgilIaIndexRoute
  '/compra-agil/': typeof CompraAgilIndexRoute
  '/licitaciones/': typeof LicitacionesIndexRoute
  '/oportunidades/': typeof OportunidadesIndexRoute
  '/ordenes-compra/': typeof OrdenesCompraIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/bi'
    | '/competidores'
    | '/configuracion'
    | '/convenios-marco'
    | '/crm'
    | '/dashboard-ia'
    | '/decisiones'
    | '/documentos'
    | '/empresa'
    | '/ia'
    | '/licitaciones'
    | '/notificaciones'
    | '/ordenes-compra'
    | '/perfilamiento'
    | '/watchlist'
    | '/bi/categorias'
    | '/bi/ia'
    | '/bi/mercado'
    | '/bi/organismos'
    | '/bi/pipeline'
    | '/bi/plazos'
    | '/competidores/$id'
    | '/compra-agil-ia/$id'
    | '/compra-agil/$id'
    | '/licitaciones/$id'
    | '/oportunidades/$id'
    | '/ordenes-compra/$codigo'
    | '/bi/'
    | '/compra-agil-ia/'
    | '/compra-agil/'
    | '/licitaciones/'
    | '/oportunidades/'
    | '/ordenes-compra/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/competidores'
    | '/configuracion'
    | '/convenios-marco'
    | '/crm'
    | '/dashboard-ia'
    | '/decisiones'
    | '/documentos'
    | '/empresa'
    | '/ia'
    | '/notificaciones'
    | '/perfilamiento'
    | '/watchlist'
    | '/bi/categorias'
    | '/bi/ia'
    | '/bi/mercado'
    | '/bi/organismos'
    | '/bi/pipeline'
    | '/bi/plazos'
    | '/competidores/$id'
    | '/compra-agil-ia/$id'
    | '/compra-agil/$id'
    | '/licitaciones/$id'
    | '/oportunidades/$id'
    | '/ordenes-compra/$codigo'
    | '/bi'
    | '/compra-agil-ia'
    | '/compra-agil'
    | '/licitaciones'
    | '/oportunidades'
    | '/ordenes-compra'
  id:
    | '__root__'
    | '/'
    | '/bi'
    | '/competidores'
    | '/configuracion'
    | '/convenios-marco'
    | '/crm'
    | '/dashboard-ia'
    | '/decisiones'
    | '/documentos'
    | '/empresa'
    | '/ia'
    | '/licitaciones'
    | '/notificaciones'
    | '/ordenes-compra'
    | '/perfilamiento'
    | '/watchlist'
    | '/bi/categorias'
    | '/bi/ia'
    | '/bi/mercado'
    | '/bi/organismos'
    | '/bi/pipeline'
    | '/bi/plazos'
    | '/competidores/$id'
    | '/compra-agil-ia/$id'
    | '/compra-agil/$id'
    | '/licitaciones/$id'
    | '/oportunidades/$id'
    | '/ordenes-compra/$codigo'
    | '/bi/'
    | '/compra-agil-ia/'
    | '/compra-agil/'
    | '/licitaciones/'
    | '/oportunidades/'
    | '/ordenes-compra/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  BiRoute: typeof BiRouteWithChildren
  CompetidoresRoute: typeof CompetidoresRouteWithChildren
  ConfiguracionRoute: typeof ConfiguracionRoute
  ConveniosMarcoRoute: typeof ConveniosMarcoRoute
  CrmRoute: typeof CrmRoute
  DashboardIaRoute: typeof DashboardIaRoute
  DecisionesRoute: typeof DecisionesRoute
  DocumentosRoute: typeof DocumentosRoute
  EmpresaRoute: typeof EmpresaRoute
  IaRoute: typeof IaRoute
  LicitacionesRoute: typeof LicitacionesRouteWithChildren
  NotificacionesRoute: typeof NotificacionesRoute
  OrdenesCompraRoute: typeof OrdenesCompraRouteWithChildren
  PerfilamientoRoute: typeof PerfilamientoRoute
  WatchlistRoute: typeof WatchlistRoute
  CompraAgilIaIdRoute: typeof CompraAgilIaIdRoute
  CompraAgilIdRoute: typeof CompraAgilIdRoute
  OportunidadesIdRoute: typeof OportunidadesIdRoute
  CompraAgilIaIndexRoute: typeof CompraAgilIaIndexRoute
  CompraAgilIndexRoute: typeof CompraAgilIndexRoute
  OportunidadesIndexRoute: typeof OportunidadesIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bi': {
      id: '/bi'
      path: '/bi'
      fullPath: '/bi'
      preLoaderRoute: typeof BiRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/competidores': {
      id: '/competidores'
      path: '/competidores'
      fullPath: '/competidores'
      preLoaderRoute: typeof CompetidoresRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/configuracion': {
      id: '/configuracion'
      path: '/configuracion'
      fullPath: '/configuracion'
      preLoaderRoute: typeof ConfiguracionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/convenios-marco': {
      id: '/convenios-marco'
      path: '/convenios-marco'
      fullPath: '/convenios-marco'
      preLoaderRoute: typeof ConveniosMarcoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/crm': {
      id: '/crm'
      path: '/crm'
      fullPath: '/crm'
      preLoaderRoute: typeof CrmRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard-ia': {
      id: '/dashboard-ia'
      path: '/dashboard-ia'
      fullPath: '/dashboard-ia'
      preLoaderRoute: typeof DashboardIaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/decisiones': {
      id: '/decisiones'
      path: '/decisiones'
      fullPath: '/decisiones'
      preLoaderRoute: typeof DecisionesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/documentos': {
      id: '/documentos'
      path: '/documentos'
      fullPath: '/documentos'
      preLoaderRoute: typeof DocumentosRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/empresa': {
      id: '/empresa'
      path: '/empresa'
      fullPath: '/empresa'
      preLoaderRoute: typeof EmpresaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ia': {
      id: '/ia'
      path: '/ia'
      fullPath: '/ia'
      preLoaderRoute: typeof IaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/licitaciones': {
      id: '/licitaciones'
      path: '/licitaciones'
      fullPath: '/licitaciones'
      preLoaderRoute: typeof LicitacionesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/notificaciones': {
      id: '/notificaciones'
      path: '/notificaciones'
      fullPath: '/notificaciones'
      preLoaderRoute: typeof NotificacionesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ordenes-compra': {
      id: '/ordenes-compra'
      path: '/ordenes-compra'
      fullPath: '/ordenes-compra'
      preLoaderRoute: typeof OrdenesCompraRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/perfilamiento': {
      id: '/perfilamiento'
      path: '/perfilamiento'
      fullPath: '/perfilamiento'
      preLoaderRoute: typeof PerfilamientoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/watchlist': {
      id: '/watchlist'
      path: '/watchlist'
      fullPath: '/watchlist'
      preLoaderRoute: typeof WatchlistRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bi/': {
      id: '/bi/'
      path: '/'
      fullPath: '/bi/'
      preLoaderRoute: typeof BiIndexRouteImport
      parentRoute: typeof BiRoute
    }
    '/bi/categorias': {
      id: '/bi/categorias'
      path: '/categorias'
      fullPath: '/bi/categorias'
      preLoaderRoute: typeof BiCategoriasRouteImport
      parentRoute: typeof BiRoute
    }
    '/bi/ia': {
      id: '/bi/ia'
      path: '/ia'
      fullPath: '/bi/ia'
      preLoaderRoute: typeof BiIaRouteImport
      parentRoute: typeof BiRoute
    }
    '/bi/mercado': {
      id: '/bi/mercado'
      path: '/mercado'
      fullPath: '/bi/mercado'
      preLoaderRoute: typeof BiMercadoRouteImport
      parentRoute: typeof BiRoute
    }
    '/bi/organismos': {
      id: '/bi/organismos'
      path: '/organismos'
      fullPath: '/bi/organismos'
      preLoaderRoute: typeof BiOrganismosRouteImport
      parentRoute: typeof BiRoute
    }
    '/bi/pipeline': {
      id: '/bi/pipeline'
      path: '/pipeline'
      fullPath: '/bi/pipeline'
      preLoaderRoute: typeof BiPipelineRouteImport
      parentRoute: typeof BiRoute
    }
    '/bi/plazos': {
      id: '/bi/plazos'
      path: '/plazos'
      fullPath: '/bi/plazos'
      preLoaderRoute: typeof BiPlazosRouteImport
      parentRoute: typeof BiRoute
    }
    '/competidores/$id': {
      id: '/competidores/$id'
      path: '/$id'
      fullPath: '/competidores/$id'
      preLoaderRoute: typeof CompetidoresIdRouteImport
      parentRoute: typeof CompetidoresRoute
    }
    '/compra-agil-ia/': {
      id: '/compra-agil-ia/'
      path: '/compra-agil-ia'
      fullPath: '/compra-agil-ia/'
      preLoaderRoute: typeof CompraAgilIaIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/compra-agil-ia/$id': {
      id: '/compra-agil-ia/$id'
      path: '/compra-agil-ia/$id'
      fullPath: '/compra-agil-ia/$id'
      preLoaderRoute: typeof CompraAgilIaIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/compra-agil/': {
      id: '/compra-agil/'
      path: '/compra-agil'
      fullPath: '/compra-agil/'
      preLoaderRoute: typeof CompraAgilIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/compra-agil/$id': {
      id: '/compra-agil/$id'
      path: '/compra-agil/$id'
      fullPath: '/compra-agil/$id'
      preLoaderRoute: typeof CompraAgilIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/licitaciones/': {
      id: '/licitaciones/'
      path: '/'
      fullPath: '/licitaciones/'
      preLoaderRoute: typeof LicitacionesIndexRouteImport
      parentRoute: typeof LicitacionesRoute
    }
    '/licitaciones/$id': {
      id: '/licitaciones/$id'
      path: '/$id'
      fullPath: '/licitaciones/$id'
      preLoaderRoute: typeof LicitacionesIdRouteImport
      parentRoute: typeof LicitacionesRoute
    }
    '/oportunidades/': {
      id: '/oportunidades/'
      path: '/oportunidades'
      fullPath: '/oportunidades/'
      preLoaderRoute: typeof OportunidadesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/oportunidades/$id': {
      id: '/oportunidades/$id'
      path: '/oportunidades/$id'
      fullPath: '/oportunidades/$id'
      preLoaderRoute: typeof OportunidadesIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ordenes-compra/': {
      id: '/ordenes-compra/'
      path: '/'
      fullPath: '/ordenes-compra/'
      preLoaderRoute: typeof OrdenesCompraIndexRouteImport
      parentRoute: typeof OrdenesCompraRoute
    }
    '/ordenes-compra/$codigo': {
      id: '/ordenes-compra/$codigo'
      path: '/$codigo'
      fullPath: '/ordenes-compra/$codigo'
      preLoaderRoute: typeof OrdenesCompraCodigoRouteImport
      parentRoute: typeof OrdenesCompraRoute
    }
  }
}

interface BiRouteChildren {
  BiCategoriasRoute: typeof BiCategoriasRoute
  BiIaRoute: typeof BiIaRoute
  BiMercadoRoute: typeof BiMercadoRoute
  BiOrganismosRoute: typeof BiOrganismosRoute
  BiPipelineRoute: typeof BiPipelineRoute
  BiPlazosRoute: typeof BiPlazosRoute
  BiIndexRoute: typeof BiIndexRoute
}

const BiRouteChildren: BiRouteChildren = {
  BiCategoriasRoute: BiCategoriasRoute,
  BiIaRoute: BiIaRoute,
  BiMercadoRoute: BiMercadoRoute,
  BiOrganismosRoute: BiOrganismosRoute,
  BiPipelineRoute: BiPipelineRoute,
  BiPlazosRoute: BiPlazosRoute,
  BiIndexRoute: BiIndexRoute,
}

const BiRouteWithChildren = BiRoute._addFileChildren(BiRouteChildren)

interface CompetidoresRouteChildren {
  CompetidoresIdRoute: typeof CompetidoresIdRoute
}

const CompetidoresRouteChildren: CompetidoresRouteChildren = {
  CompetidoresIdRoute: CompetidoresIdRoute,
}

const CompetidoresRouteWithChildren = CompetidoresRoute._addFileChildren(
  CompetidoresRouteChildren,
)

interface LicitacionesRouteChildren {
  LicitacionesIdRoute: typeof LicitacionesIdRoute
  LicitacionesIndexRoute: typeof LicitacionesIndexRoute
}

const LicitacionesRouteChildren: LicitacionesRouteChildren = {
  LicitacionesIdRoute: LicitacionesIdRoute,
  LicitacionesIndexRoute: LicitacionesIndexRoute,
}

const LicitacionesRouteWithChildren = LicitacionesRoute._addFileChildren(
  LicitacionesRouteChildren,
)

interface OrdenesCompraRouteChildren {
  OrdenesCompraCodigoRoute: typeof OrdenesCompraCodigoRoute
  OrdenesCompraIndexRoute: typeof OrdenesCompraIndexRoute
}

const OrdenesCompraRouteChildren: OrdenesCompraRouteChildren = {
  OrdenesCompraCodigoRoute: OrdenesCompraCodigoRoute,
  OrdenesCompraIndexRoute: OrdenesCompraIndexRoute,
}

const OrdenesCompraRouteWithChildren = OrdenesCompraRoute._addFileChildren(
  OrdenesCompraRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  BiRoute: BiRouteWithChildren,
  CompetidoresRoute: CompetidoresRouteWithChildren,
  ConfiguracionRoute: ConfiguracionRoute,
  ConveniosMarcoRoute: ConveniosMarcoRoute,
  CrmRoute: CrmRoute,
  DashboardIaRoute: DashboardIaRoute,
  DecisionesRoute: DecisionesRoute,
  DocumentosRoute: DocumentosRoute,
  EmpresaRoute: EmpresaRoute,
  IaRoute: IaRoute,
  LicitacionesRoute: LicitacionesRouteWithChildren,
  NotificacionesRoute: NotificacionesRoute,
  OrdenesCompraRoute: OrdenesCompraRouteWithChildren,
  PerfilamientoRoute: PerfilamientoRoute,
  WatchlistRoute: WatchlistRoute,
  CompraAgilIaIdRoute: CompraAgilIaIdRoute,
  CompraAgilIdRoute: CompraAgilIdRoute,
  OportunidadesIdRoute: OportunidadesIdRoute,
  CompraAgilIaIndexRoute: CompraAgilIaIndexRoute,
  CompraAgilIndexRoute: CompraAgilIndexRoute,
  OportunidadesIndexRoute: OportunidadesIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
